import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// Teach tailwind-merge the custom radius/shadow/font tokens from
// @taller/tokens so `cn('rounded-boton', 'rounded-full')` resolves correctly.
const merge = extendTailwindMerge({
  extend: {
    theme: {
      radius: ['boton', 'tarjeta', 'patente'],
      shadow: ['tarjeta', 'hoja'],
      font: ['titulo', 'sans', 'patente'],
    },
  },
});

export function cn(...clases: ClassValue[]) {
  return merge(clsx(clases));
}
